export class baseProjection {
    constructor(public name: string) {}
};